module.exports = __webpack_public_path__ + "img/scrabble.d0c4a59.svg";